import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=e16c0640&scoped=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/payment/payment-method-selector.scss?vue&type=style&index=0&id=e16c0640&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16c0640",
  null
  
)

export default component.exports